import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

const { grey, text, info, secondary } = colors;
const { size } = typography;

const contained = {
  base: {
    backgroundColor: grey[200],
    minHeight: pxToRem(32),
    color: text.main,
    border: `1px solid ${colors.divider}`,
    padding: `${pxToRem(5)} ${pxToRem(16)}`,

    "&:hover": {
      backgroundColor: grey[300],
    },

    "&:active, &:active:focus, &:active:hover": {
      opacity: 0.85,
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(29),
    padding: `${pxToRem(6)} ${pxToRem(18)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(40),
    padding: `${pxToRem(8)} ${pxToRem(20)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    borderColor: "transparent",
    backgroundColor: colors.primary.main,
    color: `${colors.primary.contrastText} !important`,

    "&:hover": {
      backgroundColor: colors.primary.focus,
      color: `${colors.primary.contrastText} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.primary.focus,
      color: `${colors.primary.contrastText} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: colors.primary.main,
      color: `${colors.primary.contrastText} !important`,
      opacity: 0.9,
    },
  },

  secondary: {
    borderColor: "transparent",
    backgroundColor: secondary.main,
    color: `${secondary.contrastText} !important`,

    "&:hover": {
      backgroundColor: secondary.main,
      color: `${secondary.contrastText} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: secondary.focus,
      color: `${secondary.contrastText} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: secondary.main,
      color: `${secondary.contrastText} !important`,
      opacity: 0.9,
    },
  },

  success: {
    borderColor: "transparent",
    backgroundColor: colors.success.main,
    color: `${colors.success.contrastText} !important`,

    "&:hover": {
      backgroundColor: colors.success.main,
      color: `${colors.success.contrastText} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.success.focus,
      color: `${colors.success.contrastText} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: colors.success.main,
      color: `${colors.success.contrastText} !important`,
      opacity: 0.9,
    },
  },

  warning: {
    borderColor: "transparent",
    backgroundColor: colors.warning.main,
    color: `${colors.warning.contrastText} !important`,

    "&:hover": {
      backgroundColor: colors.warning.main,
      color: `${colors.warning.contrastText} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.warning.focus,
      color: `${colors.warning.contrastText} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: colors.warning.main,
      color: `${colors.warning.contrastText} !important`,
      opacity: 0.9,
    },
  },

  error: {
    borderColor: "transparent",
    backgroundColor: colors.error.main,
    color: `${colors.error.contrastText} !important`,

    "&:hover": {
      backgroundColor: colors.error.main,
      color: `${colors.error.contrastText} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.error.focus,
      color: `${colors.error.contrastText} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: colors.error.main,
      color: `${colors.error.contrastText} !important`,
      opacity: 0.9,
    },
  },

  info: {
    borderColor: "transparent",
    backgroundColor: info.main,
    color: `${info.contrastText} !important`,

    "&:hover": {
      backgroundColor: info.focus,
      color: `${info.contrastText} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: info.focus,
      color: `${info.contrastText} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: info.main,
      color: `${info.contrastText} !important`,
      opacity: 0.9,
    },
  },

  dark: {
    borderColor: "transparent",
    backgroundColor: colors.primary.main,
    color: `${colors.primary.contrastText} !important`,

    "&:hover": {
      backgroundColor: colors.primary.focus,
      color: `${colors.primary.contrastText} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.primary.focus,
      color: `${colors.primary.contrastText} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: colors.primary.main,
      color: `${colors.primary.contrastText} !important`,
      opacity: 0.9,
    },
  },
};

export default contained;
